<template>
    <div>
        <headerNav title="更多评论" />
        <div v-if="vinfo" class="cmain">
                <div class="cheader">
                    <commenthead :item="vinfo" :showricon="true" @like="like"></commenthead>
                    <div class="cheader-content">
                        {{vinfo.content}}
                    </div>
                </div>
            
                <div class="mainlist">
                    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                        <van-list
                        v-model="navitem.loaded"
                        :finished="navitem.loadingType == 'nomore' ? true : false"
                        @load="loadData"
                        >
                        <div v-for="(item,index) in navitem.list" :key="index" class="maininfo">
                            <div>
                                <commenthead :item="item" :showricon="false"></commenthead>
                            </div>
                            <div class="maininfo-content" @click.stop="reply(item)" v-if="item.replyDealerId">
                                回复
                                <span class="maininfo-fwz-color">{{item.replyNick}}：</span>
                                <span class="maininfo-fwz-mr">{{item.content}}</span>
                            </div>
                            <div class="maininfo-content" @click.stop="reply(item)" v-if="!item.replyDealerId">
                                {{item.content}}
                            </div>
                        </div>
                        
                        </van-list>
                    </van-pull-refresh>
                    
                
                </div>
        </div>
        <div class="cfooter" v-if="vinfo" @click="gotocomment(vinfo)">
            <div class="cfooter-input">
                回复{{vinfo.dealerName}}：
            </div>
        </div>

    </div>
</template>
<script>
import commenthead from '@/components/common/heads/commenthead.vue';
export default {
    components:{
        commenthead
    },
    data(){
        return{
            vid:undefined,
            vinfo:undefined,
            navitem: {
                loadingType: "more",
                loaded: false,
                getparams: {
                    sorting: "",
                    maxResultCount: 10,
                    skipCount: 0,
                    isNeedChild:false,
                    replyCommentId:undefined
                },
                list: [],
            },
            loading: false,
            finished: false,
            refreshing: false,
        }
    },
    created(){
        var query=this.$route.query;
       
        var item=JSON.parse(query.item);
         console.log("打印参数",item);
        this.vinfo=item;
        this.navitem.getparams.replyCommentId=item.id;
    },
    methods:{
    like(item)
    {
        if(!item.isLike)
        {
            var model={
                topicId:item.topicId,
                topicCommentId:item.id
            };
           
            this.ajax.post('/api/services/app/PhoneTopic/LikeTopicComment',model).then(x=>{
                this.vinfo.isLike=true;
                this.vinfo.giveLikeCount+=1;
            })
            
        }
        else
        {
            this.ajax.post('/api/services/app/PhoneTopic/CancelTopicComment?topicCommentId='+item.id).then(x=> {
                this.vinfo.isLike=false;
                this.vinfo.giveLikeCount-=1;
            })
        }

    },
    reply(item){
        var itemjson=JSON.stringify(item);
        this.$router.push({path:'/addrecomment',query:{item:itemjson}})
    },
    onRefresh() {
        this.loadData("refresh");
    },
    gotocomment(item)
    {
        var itemjson=JSON.stringify(item);
        this.$router.push({path:'/addrecomment',query:{item:itemjson}});
    },
    loadData(source) {
        let navItem = this.navitem;
        
        if (source === "tabChange" && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
            //防止重复加载
            if (source != "refresh") {
            return;
            }
        }
        if (source === "refresh") {
            this.navitem.list = [];
            this.navitem.getparams.skipCount = 0;
        }
        navItem.loadingType = "loading";
        var params = navItem.getparams;
        //加载数据
        this.ajax
            .post("/api/services/app/PhoneTopic/QueryTopicCommentList", params)
            .then((x) => {
            this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.totalnum=x.result.totalCount;
            this.navitem.list = this.navitem.list.concat(x.result.items);
            //console.log(this.navList);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.navitem.loadingType =
                totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
            })
            .finally(() => {
            this.$set(this.navitem, "loaded", false);
            this.refreshing = false;
            });
        },
    },
}
</script>
<style lang="scss" scoped>
.cmain{
    font-size: 14px;
    margin-bottom: 50px;
}
.cheader{
    background-color: #fff;
    padding: 10px;
}
.cheader-content{
    margin-top: 10px;
}
.mainlist{
    padding: 10px;
}
.maininfo{
    margin-top:5px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
}
.maininfo-content{
    margin-top: 3px;
    padding-left:50px;
}
.maininfo-fwzs{
    background-color:#f8f8f8;
    padding: 10px;
    font-size: 13px;
}
.maininfo-fwz-color{
    color:#8085a5;
}
.cfooter{
    position: fixed;
    bottom: 0;
    left:0;
    right:0;
    background-color: #fff;
    text-align: left;
    font-size: 14px;
    border-top:1px solid #e6e6e6;
}
.cfooter-input{
    background-color: #f5f5f5;
    color:#a8a8a8;
    margin:10px;
    padding: 5px;
}
</style>